import { format } from "date-fns";

export function DateToString(fecha?: Date | string): string {
    let date: Date;

    if (fecha === undefined) {
        date = new Date();
    } else if (typeof fecha === 'string') {
        date = new Date(fecha);
    } else {
        date = fecha;
    }

    return format(date, "yyyy-MM-dd");
}

// Función para formatear la fecha
export const formatDate = (date: string | Date): string => {
    if (typeof date === 'string') {
        // Evitar el ajuste de la zona horaria al crear una nueva fecha
        const parsedDate = new Date(date);
        const utcDate = new Date(parsedDate.getTime() + parsedDate.getTimezoneOffset() * 60000);
        return format(utcDate, 'yyyy-MM-dd');
    } else {
        return format(date, 'yyyy-MM-dd');
    }
};